import { useQuery } from '@tanstack/react-query';

import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { SEARCH_QUERY_KEYS } from '../constants';
import { SearchFilters } from '../model';
import {
    loadCategoryProductsResults,
    loadFallbackCategoryProductsResults,
} from './DataLoading/LoadCategoryProductsResults';
import { useLoadQueryKeys } from './useLoadQueryKeys';

type Params = {
    limit: number;
    offset: number;
    isEnabled?: boolean;
    filters?: SearchFilters;
    sort?: Array<Record<string, 'asc' | 'desc'>>;
    segment: TeliaSegment;
    isFallback?: boolean;
};

export const useLoadCategoryProducts = ({ limit, offset, isEnabled, filters, sort, segment, isFallback }: Params) => {
    const { isLoading: isQueryKeysLoading, queryKeys } = useLoadQueryKeys(isEnabled);

    const {
        data,
        isFetching: isResultsLoading,
        error,
    } = useQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_CATEGORY_PRODUCTS, segment, limit, offset, filters, sort],
        queryFn: async ({ signal }) => {
            const loadParameters = {
                segment,
                queryKeys,
                filters,
                sort,
                limit,
                offset,
                signal,
            };
            if (isFallback) {
                return loadFallbackCategoryProductsResults(loadParameters);
            } else {
                return loadCategoryProductsResults(loadParameters);
            }
        },
        enabled: !!queryKeys && isEnabled,
    });
    useLogError(error, DDComponent.Search);

    return { isLoading: isQueryKeysLoading || isResultsLoading, error, data };
};
